'use client';

import React, { createContext, useState, useContext, useCallback } from 'react';
import CheckoutLoadingOverlay from '@/components/CheckoutLoadingOverlay';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingType, setLoadingType] = useState('checkout'); // 'checkout' or 'upsell'
  const [onCompleteCallback, setOnCompleteCallback] = useState(null);

  const showLoading = useCallback((type = 'checkout', onComplete) => {
    console.log(`🚀 Showing global loading overlay of type: ${type}`);
    setLoadingType(type);
    setOnCompleteCallback(() => onComplete);
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    console.log('✅ Hiding global loading overlay');
    setIsLoading(false);
    setOnCompleteCallback(null);
  }, []);

  const handleLoadingComplete = () => {
    console.log('🎉 Loading animation complete, executing callback...');
    if (typeof onCompleteCallback === 'function') {
      const callback = onCompleteCallback();
      if (typeof callback === 'function') {
        callback();
      }
    }
    // Don't hide here; hide is controlled by the destination page
  };

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading }}>
      {children}
      <CheckoutLoadingOverlay
        isVisible={isLoading}
        type={loadingType}
        onComplete={handleLoadingComplete}
      />
    </LoadingContext.Provider>
  );
};
